<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-help</v-icon>
        <v-toolbar-title>Block Sub Group 1 Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.accmType }}</td>
                  <td class="text-xs-left">{{ row.item.blkGrp }}</td>
                  <td class="text-xs-left">{{ row.item.blksGrp1 }}</td>
                  <td class="text-xs-left">{{ row.item.blksGrp1descS }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  props: {
    blkGrpId: Object
  },
  data() {
    return {
      headers: [
        { text: 'Accumulation Type', value: 'accmType' },
        { text: 'Block Group', value: 'blkGrp' },
        { text: 'Block Sub Group 1', value: 'blksGrp1' },
        { text: 'Short Description', value: 'blksGrp1descS' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    accmType: function (value) {
      this.doInit()
    },
    blkGrp: function (value) {
      this.doInit()
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      if (this.blkGrpId.accmType && this.blkGrpId.blkGrp) {
        const apiURI = this.menu.getBlkSubGrp1ListByBlkGrp
        if (apiURI) {
          this.loading = true
          const expand = {
            accmType: this.blkGrpId.accmType,
            blkGrp: this.blkGrpId.blkGrp
          }
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              this.items = []
              const { data } = result.data
              if (data) {
                data.map((blkSubGrp1List) => {
                  const convertList = {
                    accmType: blkSubGrp1List.accmType,
                    blkGrp: blkSubGrp1List.blkGrp,
                    blksGrp1: blkSubGrp1List.blksGrp1,
                    blksGrp1descS: blkSubGrp1List.blksGrp1descS
                  }
                  this.items.push(convertList)
                })
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      } else {
        this.items = []
      }
    },
    doSelect(data) {
      const blksGrp1 = data.blksGrp1
      this.$emit('doAssign', blksGrp1)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
